import {Component, OnInit, OnDestroy, ViewChild, Input} from '@angular/core';
import {EnvService} from "../../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../../services/auth.service";
import {MatLegacyTableDataSource as MatTableDataSource} from "@angular/material/legacy-table";
import {MatLegacyPaginator as MatPaginator} from "@angular/material/legacy-paginator";
import { debounceTime } from 'rxjs/operators';
import {LookupService} from "../../srvs/lookup";
import {UsageFilter} from "../../usage/usage.filter";
import {DialogService} from "../../services/dialog.service";
import {Mail2SmsOutFilter} from "./mail2SmsOut.filter";
import {Mail2SmsInFilter} from "./mail2SmsIn.filter";
import {ActivatedRoute, Params} from "@angular/router";
import * as moment from "moment/moment";
import {Db2SmsInFilter} from "../../db2sms/db2SmsLog/db2SmsIn.filter";

@Component({
  selector: 'micro-mail2sms-log-outgoing',
  templateUrl: './mail2sms-log-outgoing.component.html'
})
export class Mail2SmsLogOutgoingComponent implements OnInit, OnDestroy  {

  @Input() companyId:any;
  @Input() userId:any;
  @Input() fromEmail:any;
  @Input() toEmail:any;
  @Input() msisdn:any;
  @Input() status:any;
  @Input() smtpMailboxId:any;
  @Input() text:any;
  @Input() embedded:false;

  dataSource:MatTableDataSource<any> = new MatTableDataSource<any>();
  filter:Mail2SmsOutFilter = new Mail2SmsOutFilter();
  usageFilter:UsageFilter = new UsageFilter();
  timer:any;
  reloading:boolean = false;
  msgChannel:string = undefined;

  settings:any = {
    pageIndex: 0,
    pageSize: 25,
    autoRefresh: false
  }

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  constructor(public auth:AuthService,
              private env:EnvService,
              private route: ActivatedRoute,
              private http:HttpClient,
              private lookupService:LookupService,
              public dialogService:DialogService) {
  }

  ngOnInit() {
    this.route.params
      .subscribe((params: Params) => {
        this.msgChannel = params['msgChannel'];
        if (this.msgChannel) this.msgChannel = this.msgChannel.toUpperCase();
        this.loadSettings();
        this.reload();
        this.timer = setInterval(() => {
          if (this.settings.autoRefresh && !this.embedded) {
            this.reload();
          }
        }, 30000);
      });
  }

  ngOnDestroy() {
    clearInterval(this.timer);
  }

  public reload() {
    if (this.reloading) {
      return;
    }

    this.reloading = true;
    let params:HttpParams = this.filter.getParams()
      .set("page", '' + (this.paginator.pageIndex || 0))
      .set("size", '' + (this.paginator.pageSize || this.settings.pageSize))
      ;

    if (!this.embedded) {
      if (!this.usageFilter.fromInfinite) {
        params = params.set('from', '' + this.usageFilter.from);
      }

      if (!this.usageFilter.untilInfinite) {
        params = params.set('until', '' + this.usageFilter.until);
      }
    }

    this.http.get(`${this.env.e.url}/mail2sms/mo/log/${this.filter.msgChannel}`, {params:params}).subscribe(
      data => {
        let page = data as any;

        let ldate = undefined;
        for (let rec of page.content) {
          if (!ldate || rec.receivedAt !== ldate) {
            ldate = rec.receivedAt;
            rec.displayReceivedAt = true;
          } else {
            rec.displayReceivedAt = false;
          }
        }

        this.dataSource.data = page.content;
        this.paginator.pageIndex = page.number;
        this.paginator.pageSize = page.size;
        this.paginator.length = page.totalElements;
        this.reloading = false;
      }
    );
  }

  addFilterListener() {
    this.filter.anyChange.pipe(debounceTime(500)).subscribe(change => {
      this.saveSettings();
      this.paginator.pageIndex = 0;
      this.reload();
    });
  }

  addDateRangeListner() {
    this.usageFilter.anyChange.pipe().pipe(debounceTime(500)).subscribe(change => {
      this.saveSettings();
      this.paginator.pageIndex = 0;
      this.reload();
    });
  }

  loadSettings() {
    let sessionSettingsJson = sessionStorage.getItem(`mail2sms_log_out.${this.msgChannel || 'all'}`);

    if (sessionSettingsJson) {
      let sessionSettings = JSON.parse(sessionSettingsJson);
      this.settings = sessionSettings.settings;
      this.paginator.pageIndex = this.settings.pageIndex;
      this.paginator.pageSize = this.settings.pageSize;

      if (!this.embedded) {
        this.filter = new Mail2SmsOutFilter(sessionSettings.filter);
      } else {
        this.filter = new Mail2SmsOutFilter();
        this.filter.companyId = this.companyId;
        this.filter.userId = this.userId;
        this.filter.fromEmail = this.fromEmail;
        this.filter.toEmail = this.toEmail;
        this.filter.msisdn = this.msisdn;
        this.filter.status = this.status;
        this.filter.smtpMailboxId = this.smtpMailboxId;
        this.filter.text = this.text;
      }
      this.filter.msgChannel = this.msgChannel;
      this.addFilterListener();

      if (!this.embedded) {
        this.usageFilter = new UsageFilter(sessionSettings.dateRange);
        this.addDateRangeListner();
      }

    } else {
      this.usageFilter = new UsageFilter();
      this.addDateRangeListner();
      this.filter = new Mail2SmsOutFilter();
      if (this.embedded) {
        this.filter.companyId = this.companyId;
        this.filter.userId = this.userId;
        this.filter.fromEmail = this.fromEmail;
        this.filter.toEmail = this.toEmail;
        this.filter.msisdn = this.msisdn;
        this.filter.status = this.status;
        this.filter.smtpMailboxId = this.smtpMailboxId;
        this.filter.text = this.text;
      }
      this.filter.msgChannel = this.msgChannel;
      this.addFilterListener();
    }
  }

  saveSettings() {
    let oldSettings = JSON.parse(sessionStorage.getItem(`mail2sms_log_out.${this.msgChannel || 'all'}`));
    let sessionSettings = {
      filter: this.embedded ? oldSettings.filter : this.filter.toObj(),
      settings: this.settings,
      dateRange: this.embedded ? oldSettings.dateRange : this.usageFilter.toObj(),
    };

    sessionStorage.setItem(`mail2sms_log_out.${this.msgChannel || 'all'}`, JSON.stringify(sessionSettings));
  }

  pagignatorChanged() {
    if (this.paginator.pageIndex !== this.settings.pageIndex || this.paginator.pageSize !== this.settings.pageSize) {
      this.settings.pageIndex = this.paginator.pageIndex;
      this.settings.pageSize = this.paginator.pageSize;
      this.saveSettings();
    }
    this.reload();
  }
}
